



































import { Vue, Component, Prop } from "vue-property-decorator";
import { Action } from "vuex-class";
import moment from "moment";

@Component
export default class LeadNotes extends Vue {
  @Prop({ required: true }) lead!: any;
  @Action("addLeadNote") addLeadNote!: Function;
  @Action("getLeadNotes") getLeadNotes!: Function;

  newNote: string = "";
  notes: any[] = [];
  loadingNotes = false;

  created() {
    this.getNotes();
  }

  handleEnter(e: KeyboardEvent) {
    if (e.code !== "Enter") return;
    this.newNote && this.handleAddNote(true);
  }

  async handleAddNote(clear = false) {
    this.loadingNotes = true;
    const note = await this.addLeadNote({
      leadId: this.lead.id,
      note: this.newNote
    });
    if (note && note.id) {
      this.notes = [...this.notes, note];
      if (clear) this.newNote = "";
    }
    this.loadingNotes = false;
  }

  async getNotes() {
    this.loadingNotes = true;
    const notes = await this.getLeadNotes(this.lead.id);
    if (Array.isArray(notes)) {
      this.notes = notes;
    }
    this.loadingNotes = false;
    window.console.log("notes", this.notes);
  }

  formatTime(ts: number) {
    return moment.unix(ts).fromNow();
  }
}
